<script>
import {DateTime, Info} from "luxon";

export default {
  install(Vue) {
    Vue.$dateTimePlugin = DateTime
    Vue.$luxon = {
      DateTime,
      Info
    }
  }
}
</script>